<template>
  <div class="page">
    <!-- 头部导航 -->
    <van-nav-bar
      title="积分充值"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      class="nav-bar"
    />

    <!-- 充值记录列表 -->
    <div class="content">
      <div v-if="loading" class="loading-container">
        <van-loading type="spinner" color="#1989fa"></van-loading>
      </div>
      
      <div v-else-if="rechargeList.length === 0" class="empty-container">
        <van-empty description="暂无充值记录" />
      </div>
      
      <div v-else class="record-list">
        <div 
          v-for="(record, index) in rechargeList" 
          :key="index"
          class="record-item"
        >
          <div class="record-content">
            <div class="record-info">
              <div class="amount-info">
                <span class="amount">充值 ¥{{ record.total_fee }}</span>
                <span class="status-badge" :class="getStatusClass(record.status)">
                  {{ getStatusText(record.status) }}
                </span>
              </div>
              <div class="pay-method">{{ getPayMethodText(record.pay_type) }}</div>
            </div>
            <div class="record-time">{{ formatTime(record.create_time) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>

<script>
import axios from 'axios'
import { API_ENDPOINTS } from '@/config/api'
import BottomNavigation from '@/components/BottomNavigation.vue'

export default {
  components: {
    BottomNavigation
  },
  data() {
    return {
      loading: true,
      rechargeList: []
    };
  },
  async mounted() {
    await this.getRechargeHistory();
  },
  methods: {
    showToast(message) {
      this.$toast(message);
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 获取充值记录
    async getRechargeHistory() {
      this.loading = true;
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const res = await axios.get(API_ENDPOINTS.USER.RECHARGE_LIST, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.rechargeList = res.data.data || [];
        } else {
          this.showToast(res.data.message || '获取充值记录失败');
        }
      } catch (error) {
        console.error('获取充值记录失败:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        } else {
          this.showToast('获取充值记录失败，请重试');
        }
      } finally {
        this.loading = false;
      }
    },

    // 获取状态文字
    getStatusText(status) {
      const statusMap = {
        0: '待创建',
        1: '待支付',
        2: '已支付',
        3: '已取消'
      };
      return statusMap[status] || '未知状态';
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        0: 'status-pending',
        1: 'status-waiting',
        2: 'status-success',
        3: 'status-cancelled'
      };
      return classMap[status] || 'status-unknown';
    },

    // 获取支付方式文字
    getPayMethodText(payType) {
      const methodMap = {
        'wechat': 'wechat',
        'alipay': 'alipay',
        'wechat_native': 'wechat'
      };
      return methodMap[payType] || payType;
    },

    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style scoped>
.page {
  background-color: rgba(247, 247, 247, 1);
  min-height: 100vh;
  padding-bottom: 80px;
  width: 100%;
}

.nav-bar {
  background-color: white;
  border-bottom: 1px solid #ebedf0;
}

.content {
  padding: 16px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.loading-container .van-loading__text {
  font-size: 14px !important;
  color: #666;
}

.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.record-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.record-item:active {
  transform: scale(0.98);
}

.record-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-info {
  flex: 1;
}

.amount-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.amount {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-success {
  background-color: #f0f9ff;
  color: #10b981;
  border: 1px solid #10b981;
}

.status-waiting {
  background-color: #fef3c7;
  color: #f59e0b;
  border: 1px solid #f59e0b;
}

.status-pending {
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #6b7280;
}

.status-cancelled {
  background-color: #fef2f2;
  color: #ef4444;
  border: 1px solid #ef4444;
}

.status-unknown {
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #6b7280;
}

.pay-method {
  font-size: 14px;
  color: #666;
}

.record-time {
  font-size: 12px;
  color: #999;
  text-align: right;
  white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .content {
    padding: 12px;
  }
  
  .record-item {
    padding: 14px;
    border-radius: 10px;
  }
  
  .amount {
    font-size: 15px;
  }
  
  .record-time {
    font-size: 11px;
  }
}
</style>
